export default __webpack_public_path__ + "static/media/493.1c9599bb.jpg";